import React from 'react'
import gql from 'graphql-tag'
import {useMutation} from '@apollo/react-hooks'
import {notification} from 'antd'
import AddInvoiceLineModalForm, {Item, FormValues} from './AddInvoiceLineModalForm'

interface Props {
  availableExpenseItems: [Item]
  bookingId: string
  open: boolean
  onClose: () => void
  onInvoiceLine: () => void
}

const createInvoiceLineMutation = gql`
  mutation CreateServiceProviderInvoiceLine($input: ServiceProviderInvoiceLineInput!) {
    CreateServiceProviderInvoiceLine(input: $input) {
      id
    }
  }
`

function AddInvoiceLineModal({
  availableExpenseItems,
  bookingId,
  open,
  onClose,
  onInvoiceLine,
}: Props) {
  const [createInvoiceLine, {loading}] = useMutation(createInvoiceLineMutation)

  function handleSubmit({cost, quantity, ...rest}: FormValues) {
    createInvoiceLine({
      variables: {
        input: {
          bookingId,
          ...rest,
          cost: cost ? Number(cost) : null,
          quantity: quantity ? Number(quantity) : null
        }
      },
    }).then(() => {
      notification.success({
        message: 'Fakturalinjen er nå opprettet',
      })
      onInvoiceLine()
    }).catch(() => {
      notification.error({
        message: 'Kunne ikke opprette fakturalinje',
        description: 'Fakturalinjen kunne ikke opprettes. Forsøk på nytt eller kontakt EFKT.',
      })
    })
  }

  if (open) {
    return (
      <AddInvoiceLineModalForm
        onClose={onClose}
        onSubmit={handleSubmit}
        submitting={loading}
        availableExpenseItems={availableExpenseItems}
      />
    )
  }

  return null
}

export default AddInvoiceLineModal
